var map = {
	"./Acid rain.svg": 11691,
	"./Air.svg": 61536,
	"./Airplane.svg": 90014,
	"./Alarm clock.svg": 74349,
	"./Alchemist.svg": 49884,
	"./Alcohol.svg": 11726,
	"./Algae.svg": 50220,
	"./Alien.svg": 7185,
	"./Allergy.svg": 84832,
	"./Alligator.svg": 28501,
	"./Alpaca.svg": 50606,
	"./Ambulance.svg": 10202,
	"./Angel.svg": 56367,
	"./Angler.svg": 83029,
	"./Animal.svg": 46668,
	"./Ant farm.svg": 74841,
	"./Ant.svg": 26335,
	"./Antarctica.svg": 16164,
	"./Anthill.svg": 19110,
	"./Apron.svg": 36728,
	"./Aquarium.svg": 13985,
	"./Archeologist.svg": 38814,
	"./Archipelago.svg": 52679,
	"./Arctic.svg": 74640,
	"./Armadillo.svg": 37977,
	"./Armor.svg": 84545,
	"./Arrow.svg": 21007,
	"./Ash.svg": 37652,
	"./Astronaut.svg": 62809,
	"./Astronomer.svg": 22572,
	"./Atmosphere.svg": 75844,
	"./Atomic bomb.svg": 12485,
	"./Aurora.svg": 74136,
	"./Avalanche.svg": 583,
	"./Aviary.svg": 98100,
	"./Axe.svg": 8048,
	"./Babe the blue ox.svg": 31136,
	"./Bacon.svg": 31253,
	"./Bacteria.svg": 18721,
	"./Baker.svg": 50907,
	"./Bakery.svg": 10184,
	"./Banana bread.svg": 23641,
	"./Banana.svg": 23759,
	"./Bandage.svg": 66910,
	"./Bank.svg": 16310,
	"./Barn.svg": 76199,
	"./Barrel.svg": 53832,
	"./Bat.svg": 76357,
	"./Batter.svg": 29838,
	"./Battery.svg": 98923,
	"./Bayonet.svg": 77360,
	"./Bbq.svg": 89729,
	"./Beach.svg": 4605,
	"./Beaver.svg": 58931,
	"./Bee.svg": 65184,
	"./Beehive.svg": 30554,
	"./Beekeeper.svg": 102,
	"./Beer.svg": 99666,
	"./Bell.svg": 56799,
	"./Bicycle.svg": 54399,
	"./Big.svg": 71294,
	"./Binoculars.svg": 48926,
	"./Bird.svg": 79829,
	"./Birdcage.svg": 1757,
	"./Birdhouse.svg": 33979,
	"./Black hole.svg": 33673,
	"./Blade.svg": 97434,
	"./Blender.svg": 84556,
	"./Blizzard.svg": 94458,
	"./Blood bag.svg": 77366,
	"./Blood.svg": 2140,
	"./Boat.svg": 79390,
	"./Boiler.svg": 69103,
	"./Bone.svg": 61334,
	"./Bonsai tree.svg": 66298,
	"./Book.svg": 44147,
	"./Bottle.svg": 13996,
	"./Boulder.svg": 61715,
	"./Bow.svg": 26368,
	"./Box.svg": 85495,
	"./Bread.svg": 72870,
	"./Brick.svg": 74611,
	"./Bridge.svg": 11803,
	"./Broom.svg": 21483,
	"./Bucket.svg": 75222,
	"./Bullet.svg": 14060,
	"./Bulletproof vest.svg": 27400,
	"./Bus.svg": 77006,
	"./Butcher.svg": 94157,
	"./Butter.svg": 62418,
	"./Butterfly net.svg": 92328,
	"./Butterfly.svg": 14821,
	"./Cable car.svg": 24821,
	"./Cactus.svg": 5433,
	"./Cage.svg": 73004,
	"./Cake.svg": 43888,
	"./Camel.svg": 20214,
	"./Campfire.svg": 46455,
	"./Candle.svg": 28235,
	"./Candy cane.svg": 99446,
	"./Cannon.svg": 35819,
	"./Canvas.svg": 92704,
	"./Car.svg": 53958,
	"./Caramel.svg": 51287,
	"./Carbon dioxide.svg": 22883,
	"./Carrot.svg": 87937,
	"./Cart.svg": 58934,
	"./Cashmere.svg": 63356,
	"./Castle.svg": 59488,
	"./Cat.svg": 21688,
	"./Catnip.svg": 24849,
	"./Cauldron.svg": 55690,
	"./Cave.svg": 60827,
	"./Caviar.svg": 88230,
	"./Centaur.svg": 25942,
	"./Cereal.svg": 31852,
	"./Chain.svg": 53687,
	"./Chainsaw.svg": 28366,
	"./Chameleon.svg": 86002,
	"./Charcoal.svg": 54525,
	"./Cheese.svg": 30139,
	"./Cheeseburger.svg": 54900,
	"./Chicken coop.svg": 57004,
	"./Chicken soup.svg": 39026,
	"./Chicken wing.svg": 86418,
	"./Chicken.svg": 53633,
	"./Chill.svg": 5942,
	"./Chimney.svg": 51149,
	"./Chocolate milk.svg": 9323,
	"./Chocolate.svg": 21154,
	"./Christmas stocking.svg": 88374,
	"./Christmas tree.svg": 51568,
	"./Cigarette.svg": 2764,
	"./Circus.svg": 76001,
	"./City.svg": 53593,
	"./Clay.svg": 40143,
	"./Clock.svg": 13102,
	"./Closet.svg": 9524,
	"./Cloud.svg": 94359,
	"./Coal.svg": 36385,
	"./Coconut milk.svg": 52562,
	"./Coconut.svg": 87073,
	"./Coffin.svg": 89951,
	"./Cold.svg": 2530,
	"./Combustion engine.svg": 13713,
	"./Computer mouse.svg": 8334,
	"./Computer.svg": 59031,
	"./Confetti.svg": 93284,
	"./Constellation.svg": 32501,
	"./Container.svg": 30649,
	"./Continent.svg": 9520,
	"./Cook.svg": 42760,
	"./Cookbook.svg": 50455,
	"./Cookie cutter.svg": 76003,
	"./Cookie dough.svg": 83191,
	"./Cookie.svg": 96190,
	"./Coral.svg": 40275,
	"./Corpse.svg": 45368,
	"./Cotton candy.svg": 25562,
	"./Cotton.svg": 70197,
	"./Cow.svg": 40857,
	"./Crayon.svg": 94470,
	"./Crow.svg": 77961,
	"./Crystal ball.svg": 60297,
	"./Cuckoo.svg": 77340,
	"./Cup.svg": 64272,
	"./Current.svg": 85579,
	"./Cutting board.svg": 18000,
	"./Cyborg.svg": 30872,
	"./Cyclist.svg": 75451,
	"./Dam.svg": 26150,
	"./Darkness.svg": 99713,
	"./Dawn.svg": 41266,
	"./Day.svg": 85418,
	"./Death.svg": 72850,
	"./Desert.svg": 77807,
	"./Dew.svg": 75336,
	"./Diamond.svg": 65312,
	"./Dinosaur.svg": 87629,
	"./Diver.svg": 68460,
	"./Doctor.svg": 95861,
	"./Dog.svg": 8122,
	"./Doge.svg": 91579,
	"./Doghouse.svg": 87834,
	"./Domestication.svg": 85999,
	"./Don quixote.svg": 49494,
	"./Donut.svg": 40528,
	"./Double rainbow.svg": 33037,
	"./Dough.svg": 9149,
	"./Dragon.svg": 26157,
	"./Drone.svg": 90346,
	"./Drum.svg": 78892,
	"./Drunk.svg": 742,
	"./Dry ice.svg": 7414,
	"./Duck.svg": 27303,
	"./Duckling.svg": 87071,
	"./Dune.svg": 79310,
	"./Dust.svg": 25392,
	"./Dynamite.svg": 32493,
	"./Eagle.svg": 91064,
	"./Earth.svg": 1904,
	"./Earthquake.svg": 34963,
	"./Eclipse.svg": 38495,
	"./Egg timer.svg": 62104,
	"./Egg.svg": 3307,
	"./Electric car.svg": 25519,
	"./Electric eel.svg": 38175,
	"./Electrician.svg": 20987,
	"./Electricity.svg": 36839,
	"./Email.svg": 91884,
	"./Energy.svg": 22904,
	"./Engineer.svg": 66531,
	"./Eruption.svg": 63848,
	"./Excalibur.svg": 7241,
	"./Excavator.svg": 35795,
	"./Explosion.svg": 65241,
	"./Fabric.svg": 97407,
	"./Factory.svg": 5902,
	"./Fairy tale.svg": 91805,
	"./Family tree.svg": 37540,
	"./Family.svg": 35548,
	"./Farm.svg": 10040,
	"./Farmer.svg": 98301,
	"./Faun.svg": 51974,
	"./Fence.svg": 10223,
	"./Field.svg": 55784,
	"./Fire extinguisher.svg": 78237,
	"./Fire.svg": 28952,
	"./Firefighter.svg": 18235,
	"./Fireplace.svg": 24937,
	"./Firestation.svg": 40356,
	"./Firetruck.svg": 97513,
	"./Firewall.svg": 57196,
	"./Fireworks.svg": 58302,
	"./Fish.svg": 12626,
	"./Fishing rod.svg": 81133,
	"./Flamethrower.svg": 18054,
	"./Flashlight.svg": 48966,
	"./Flood.svg": 78736,
	"./Flour.svg": 81440,
	"./Flower.svg": 889,
	"./Flute.svg": 33914,
	"./Flying fish.svg": 21605,
	"./Flying squirrel.svg": 2190,
	"./Fog.svg": 1588,
	"./Force knight.svg": 59804,
	"./Forest.svg": 59415,
	"./Fork.svg": 68384,
	"./Fortune cookie.svg": 14363,
	"./Fossil.svg": 61260,
	"./Fountain.svg": 78520,
	"./Fox.svg": 16371,
	"./Frankenstein's monster.svg": 71136,
	"./French fries.svg": 97853,
	"./Fridge.svg": 56975,
	"./Frog.svg": 77974,
	"./Frozen yogurt.svg": 18304,
	"./Fruit tree.svg": 31690,
	"./Fruit.svg": 30658,
	"./Galaxy cluster.svg": 92714,
	"./Galaxy.svg": 78140,
	"./Garage.svg": 16379,
	"./Garden.svg": 44615,
	"./Gardener.svg": 61946,
	"./Gas.svg": 26347,
	"./Geyser.svg": 93801,
	"./Ghost.svg": 95905,
	"./Gift.svg": 25838,
	"./Gingerbread house.svg": 34018,
	"./Gingerbread man.svg": 14342,
	"./Glacier.svg": 98203,
	"./Glass.svg": 29896,
	"./Glasses.svg": 80428,
	"./Gnome.svg": 88612,
	"./Goat.svg": 3797,
	"./Gold.svg": 47222,
	"./Golem.svg": 2944,
	"./Granite.svg": 11634,
	"./Grass.svg": 57322,
	"./Grave.svg": 91071,
	"./Gravestone.svg": 32150,
	"./Graveyard.svg": 78227,
	"./Greenhouse.svg": 4579,
	"./Grenade.svg": 89694,
	"./Grilled cheese.svg": 9114,
	"./Grim reaper.svg": 86358,
	"./Gun.svg": 2474,
	"./Gunpowder.svg": 12849,
	"./Gust.svg": 31841,
	"./Hacker.svg": 14858,
	"./Hail.svg": 31382,
	"./Ham.svg": 37570,
	"./Hamburger.svg": 49009,
	"./Hammer.svg": 58886,
	"./Hamster.svg": 5846,
	"./Hangar.svg": 3805,
	"./Harp.svg": 77775,
	"./Hay bale.svg": 30348,
	"./Hay.svg": 83678,
	"./Heat.svg": 99826,
	"./Hedge.svg": 6835,
	"./Hedgehog.svg": 79027,
	"./Helicopter.svg": 13551,
	"./Hero.svg": 49124,
	"./Hill.svg": 62645,
	"./Hippo.svg": 80560,
	"./Honey.svg": 13665,
	"./Horizon.svg": 90165,
	"./Horse.svg": 90091,
	"./Horseshoe.svg": 16298,
	"./Hospital.svg": 53134,
	"./Hot chocolate.svg": 16187,
	"./Hourglass.svg": 99466,
	"./House.svg": 6824,
	"./Human.svg": 951,
	"./Hummingbird.svg": 50184,
	"./Hurricane.svg": 49169,
	"./Husky.svg": 61240,
	"./Ice cream truck.svg": 72554,
	"./Ice cream.svg": 79075,
	"./Ice sculpture.svg": 18384,
	"./Ice.svg": 46857,
	"./Iceberg.svg": 12375,
	"./Iced tea.svg": 32781,
	"./Idea.svg": 7453,
	"./Igloo.svg": 62838,
	"./Internet.svg": 92347,
	"./Island.svg": 44995,
	"./Ivy.svg": 12330,
	"./Jack-o'-lantern.svg": 63183,
	"./Jam.svg": 90116,
	"./Jar.svg": 5539,
	"./Jerky.svg": 59147,
	"./Juice.svg": 77944,
	"./Jupiter.svg": 76407,
	"./Kaiju.svg": 70770,
	"./Katana.svg": 19166,
	"./Kite.svg": 55237,
	"./Knife.svg": 71711,
	"./Knight.svg": 19139,
	"./Lake.svg": 21357,
	"./Lamp.svg": 56290,
	"./Land.svg": 81211,
	"./Laptop.svg": 57200,
	"./Lasso.svg": 35238,
	"./Lava lamp.svg": 3680,
	"./Lava.svg": 48110,
	"./Lawn mower.svg": 79080,
	"./Lawn.svg": 87466,
	"./Leaf.svg": 91660,
	"./Leather.svg": 73347,
	"./Legend.svg": 68047,
	"./Lens.svg": 57496,
	"./Letter.svg": 29548,
	"./Librarian.svg": 36460,
	"./Library.svg": 26445,
	"./Life.svg": 99962,
	"./Light bulb.svg": 26957,
	"./Light sword.svg": 65435,
	"./Light.svg": 48984,
	"./Lighthouse.svg": 54508,
	"./Lightning.svg": 4026,
	"./Lion.svg": 48266,
	"./Liquid.svg": 37196,
	"./Little alchemy (element).svg": 42736,
	"./Livestock.svg": 13208,
	"./Lizard.svg": 84960,
	"./Log cabin.svg": 53825,
	"./Love.svg": 83204,
	"./Lumberjack.svg": 21156,
	"./Mac and cheese.svg": 67493,
	"./Machine.svg": 47731,
	"./Magic.svg": 53005,
	"./Magma.svg": 867,
	"./Mail truck.svg": 88284,
	"./Mailbox.svg": 94684,
	"./Mailman.svg": 5567,
	"./Manatee.svg": 22381,
	"./Map.svg": 70198,
	"./Maple syrup.svg": 41942,
	"./Mars.svg": 34783,
	"./Marshmallows.svg": 93376,
	"./Mayonnaise.svg": 45868,
	"./Meat.svg": 92381,
	"./Medusa.svg": 12235,
	"./Mercury.svg": 98627,
	"./Mermaid.svg": 55829,
	"./Metal.svg": 39157,
	"./Meteor.svg": 6572,
	"./Meteoroid.svg": 83036,
	"./Microscope.svg": 96060,
	"./Milk shake.svg": 59367,
	"./Milk.svg": 49005,
	"./Mineral.svg": 71454,
	"./Minotaur.svg": 5243,
	"./Mirror.svg": 18709,
	"./Mist.svg": 58987,
	"./Mold.svg": 11740,
	"./Monarch.svg": 93386,
	"./Money.svg": 94544,
	"./Monkey.svg": 46407,
	"./Moon rover.svg": 89575,
	"./Moon.svg": 29887,
	"./Moss.svg": 1158,
	"./Moth.svg": 31408,
	"./Motion.svg": 44570,
	"./Motorcycle.svg": 11883,
	"./Mountain goat.svg": 92418,
	"./Mountain range.svg": 82662,
	"./Mountain.svg": 9949,
	"./Mouse.svg": 77573,
	"./Mousetrap.svg": 12960,
	"./Mud.svg": 79910,
	"./Mummy.svg": 15985,
	"./Music.svg": 56733,
	"./Musician.svg": 79679,
	"./Narwhal.svg": 16765,
	"./Needle.svg": 55497,
	"./Nessie.svg": 38991,
	"./Nest.svg": 63634,
	"./Net.svg": 43373,
	"./Newspaper.svg": 3021,
	"./Night.svg": 96342,
	"./Ninja turtle.svg": 27374,
	"./Ninja.svg": 66304,
	"./Nuts.svg": 7604,
	"./Oasis.svg": 33795,
	"./Obsidian.svg": 33939,
	"./Ocean.svg": 96462,
	"./Oil.svg": 68476,
	"./Omelette.svg": 42717,
	"./Optical fiber.svg": 5406,
	"./Orchard.svg": 50301,
	"./Ore.svg": 67684,
	"./Organic matter.svg": 7530,
	"./Origami.svg": 70218,
	"./Ostrich.svg": 40292,
	"./Owl.svg": 72358,
	"./Oxygen.svg": 28164,
	"./Ozone.svg": 32265,
	"./Paint.svg": 49848,
	"./Painter.svg": 75325,
	"./Painting.svg": 97744,
	"./Paleontologist.svg": 77910,
	"./Palm.svg": 99652,
	"./Pan flute.svg": 78007,
	"./Paper airplane.svg": 78072,
	"./Paper cup.svg": 42114,
	"./Paper.svg": 42290,
	"./Parachute.svg": 42157,
	"./Paraglider.svg": 18897,
	"./Park.svg": 13468,
	"./Parrot.svg": 52660,
	"./Pasta.svg": 26537,
	"./Peacock.svg": 25946,
	"./Peanut butter.svg": 73631,
	"./Peat.svg": 54394,
	"./Pebble.svg": 46016,
	"./Pegasus.svg": 90000,
	"./Pencil sharpener.svg": 36539,
	"./Pencil.svg": 52235,
	"./Penguin.svg": 54732,
	"./Penicillin.svg": 95483,
	"./Perfume.svg": 812,
	"./Petroleum.svg": 48737,
	"./Philosophy.svg": 19197,
	"./Phoenix.svg": 63573,
	"./Picnic.svg": 19822,
	"./Pie.svg": 17162,
	"./Pig.svg": 53640,
	"./Pigeon.svg": 33838,
	"./Piggy bank.svg": 8806,
	"./Pilot.svg": 34414,
	"./Pinocchio.svg": 6810,
	"./Pipe.svg": 13640,
	"./Piranha.svg": 32685,
	"./Pirate ship.svg": 9215,
	"./Pirate.svg": 36671,
	"./Pitchfork.svg": 86402,
	"./Pizza.svg": 87958,
	"./Planet.svg": 83474,
	"./Plankton.svg": 81363,
	"./Plant.svg": 74755,
	"./Plasma.svg": 58366,
	"./Platypus.svg": 52760,
	"./Plow.svg": 88698,
	"./Polar bear.svg": 3522,
	"./Pollen.svg": 4714,
	"./Pond.svg": 42113,
	"./Popsicle.svg": 20673,
	"./Post office.svg": 56214,
	"./Potato.svg": 55525,
	"./Potter.svg": 14702,
	"./Pottery.svg": 4619,
	"./Pressure.svg": 73141,
	"./Primordial soup.svg": 39286,
	"./Printer.svg": 67200,
	"./Prism.svg": 64723,
	"./Pterodactyl.svg": 36055,
	"./Puddle.svg": 98208,
	"./Pumpkin.svg": 92620,
	"./Pyramid.svg": 36280,
	"./Quicksand.svg": 24827,
	"./Quicksilver.svg": 37142,
	"./Rabbit.svg": 49084,
	"./Rain.svg": 66854,
	"./Rainbow.svg": 58818,
	"./Rainforest.svg": 70081,
	"./Rat.svg": 245,
	"./Recipe.svg": 60542,
	"./Reed.svg": 45116,
	"./Reindeer.svg": 16822,
	"./Restaurant.svg": 45537,
	"./Ring.svg": 77226,
	"./River.svg": 28930,
	"./Rivulet.svg": 18687,
	"./Robot vacuum.svg": 39429,
	"./Robot.svg": 36620,
	"./Rock.svg": 59231,
	"./Rocket.svg": 44860,
	"./Roe.svg": 47490,
	"./Roller coaster.svg": 66791,
	"./Rope.svg": 21040,
	"./Rose.svg": 39193,
	"./Ruins.svg": 60965,
	"./Ruler.svg": 76456,
	"./Rust.svg": 42974,
	"./Rv.svg": 50284,
	"./Sack.svg": 382,
	"./Saddle.svg": 1797,
	"./Safe.svg": 37947,
	"./Safety glasses.svg": 59118,
	"./Sailboat.svg": 27901,
	"./Sailor.svg": 80992,
	"./Salt.svg": 72028,
	"./Samurai.svg": 53226,
	"./Sand castle.svg": 8178,
	"./Sand.svg": 19106,
	"./Sandpaper.svg": 8552,
	"./Sandstone.svg": 74185,
	"./Sandstorm.svg": 73645,
	"./Sandwich.svg": 56695,
	"./Santa.svg": 35932,
	"./Sap.svg": 13044,
	"./Saturn.svg": 7441,
	"./Scalpel.svg": 29132,
	"./Scarecrow.svg": 91345,
	"./Science.svg": 89194,
	"./Scissors.svg": 80605,
	"./Scorpion.svg": 45935,
	"./Scuba tank.svg": 23188,
	"./Scythe.svg": 69456,
	"./Sea.svg": 6769,
	"./Seagull.svg": 71017,
	"./Seahorse.svg": 97484,
	"./Seal.svg": 63463,
	"./Seaplane.svg": 67593,
	"./Seasickness.svg": 77130,
	"./Seaweed.svg": 3238,
	"./Seed.svg": 67387,
	"./Sewing machine.svg": 16246,
	"./Shark.svg": 98299,
	"./Sheep.svg": 68281,
	"./Sheet music.svg": 98612,
	"./Shovel.svg": 50769,
	"./Shuriken.svg": 33741,
	"./Sickness.svg": 95867,
	"./Silo.svg": 38671,
	"./Skateboard.svg": 96834,
	"./Skeleton.svg": 99849,
	"./Ski goggles.svg": 44831,
	"./Skier.svg": 14350,
	"./Sky.svg": 37187,
	"./Skyscraper.svg": 21155,
	"./Sleigh.svg": 92274,
	"./Sloth.svg": 10432,
	"./Small.svg": 35097,
	"./Smartphone.svg": 14853,
	"./Smog.svg": 80818,
	"./Smoke signal.svg": 3949,
	"./Smoke.svg": 61511,
	"./Smoothie.svg": 55628,
	"./Snake.svg": 60556,
	"./Snow globe.svg": 10862,
	"./Snow.svg": 13733,
	"./Snowball.svg": 11094,
	"./Snowboard.svg": 11727,
	"./Snowboarder.svg": 75426,
	"./Snowman.svg": 17955,
	"./Snowmobile.svg": 46243,
	"./Soap.svg": 99253,
	"./Soda.svg": 56087,
	"./Soil.svg": 5849,
	"./Solar cell.svg": 24929,
	"./Solar system.svg": 80890,
	"./Solid.svg": 63593,
	"./Sound.svg": 25481,
	"./Space station.svg": 19614,
	"./Space.svg": 78278,
	"./Spaceship.svg": 30800,
	"./Spaghetti.svg": 84921,
	"./Sphinx.svg": 15726,
	"./Spider.svg": 53455,
	"./Spoon.svg": 58435,
	"./Spotlight.svg": 51200,
	"./Sprinkles.svg": 15353,
	"./Squirrel.svg": 80449,
	"./Star.svg": 59324,
	"./Starfish.svg": 46106,
	"./Statue.svg": 73428,
	"./Steak.svg": 17506,
	"./Steam engine.svg": 16458,
	"./Steam.svg": 88780,
	"./Steamboat.svg": 91142,
	"./Steel wool.svg": 45676,
	"./Steel.svg": 85145,
	"./Stethoscope.svg": 82819,
	"./Stone.svg": 81595,
	"./Storm.svg": 53399,
	"./Story.svg": 83451,
	"./Stream.svg": 69356,
	"./String phone.svg": 5255,
	"./Stun gun.svg": 89986,
	"./Sugar.svg": 81478,
	"./Sun.svg": 75190,
	"./Sundial.svg": 42876,
	"./Sunflower.svg": 20795,
	"./Sunglasses.svg": 23986,
	"./Supernova.svg": 63495,
	"./Surfer.svg": 33573,
	"./Sushi.svg": 71034,
	"./Swamp.svg": 48360,
	"./Sweater.svg": 32465,
	"./Swim goggles.svg": 2508,
	"./Swimmer.svg": 41804,
	"./Swimming pool.svg": 51579,
	"./Sword.svg": 85431,
	"./Swordfish.svg": 77145,
	"./Syringe.svg": 52683,
	"./Tablet.svg": 59508,
	"./Tailor.svg": 84249,
	"./Tank.svg": 25796,
	"./Tea.svg": 23254,
	"./Telescope.svg": 18528,
	"./Tent.svg": 52303,
	"./The one ring.svg": 68865,
	"./Thermometer.svg": 80368,
	"./Thread.svg": 26380,
	"./Tide.svg": 88584,
	"./Time.svg": 64431,
	"./Titanic.svg": 61502,
	"./Toast.svg": 77985,
	"./Tobacco.svg": 53397,
	"./Tool.svg": 32458,
	"./Toolbox.svg": 15049,
	"./Tornado.svg": 73947,
	"./Toucan.svg": 14310,
	"./Tractor.svg": 46829,
	"./Train.svg": 17898,
	"./Trainyard.svg": 81990,
	"./Treasure map.svg": 67045,
	"./Treasure.svg": 16423,
	"./Tree.svg": 48068,
	"./Treehouse.svg": 34168,
	"./Trojan horse.svg": 41623,
	"./Tsunami.svg": 49401,
	"./Tunnel.svg": 52538,
	"./Turtle.svg": 67562,
	"./Twilight.svg": 15320,
	"./Tyrannosaurus rex.svg": 83073,
	"./Ufo.svg": 58880,
	"./Umbrella.svg": 78032,
	"./Unicorn.svg": 50620,
	"./Universe.svg": 65917,
	"./Vacuum cleaner.svg": 86531,
	"./Vampire.svg": 46766,
	"./Vase.svg": 87039,
	"./Vault.svg": 49888,
	"./Vegetable.svg": 78165,
	"./Venus.svg": 53827,
	"./Village.svg": 26628,
	"./Vine.svg": 58500,
	"./Vinegar.svg": 20042,
	"./Volcano.svg": 96090,
	"./Vulture.svg": 32135,
	"./Wagon.svg": 98568,
	"./Wall.svg": 73216,
	"./Wand.svg": 85630,
	"./Warmth.svg": 20519,
	"./Warrior.svg": 9370,
	"./Watch.svg": 37525,
	"./Water gun.svg": 34403,
	"./Water lily.svg": 48595,
	"./Water pipe.svg": 72127,
	"./Water.svg": 17025,
	"./Waterfall.svg": 50470,
	"./Wave.svg": 28839,
	"./Wax.svg": 82832,
	"./Web.svg": 34334,
	"./Werewolf.svg": 48563,
	"./Wheat.svg": 28725,
	"./Wheel.svg": 43033,
	"./Wild boar.svg": 74836,
	"./Wind turbine.svg": 93551,
	"./Wind.svg": 15318,
	"./Windmill.svg": 14828,
	"./Windsurfer.svg": 9511,
	"./Wine.svg": 2439,
	"./Wire.svg": 84371,
	"./Witch.svg": 64701,
	"./Wizard.svg": 31593,
	"./Wolf.svg": 70628,
	"./Wood.svg": 78467,
	"./Woodpecker.svg": 1077,
	"./Wool.svg": 71451,
	"./Wrapping paper.svg": 3510,
	"./Writer.svg": 13473,
	"./Yeti.svg": 36023,
	"./Yogurt.svg": 73082,
	"./Zombie.svg": 93306,
	"./Zoo.svg": 74832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3548;